import { getStyleProperty } from '../utilities'

export const AJAX_URL = window.ANNA_LINDER.ajax
export const LOADING_CLASS = 'is-loading'

export const isProduction = window.location.hostname.includes('local') === false
export const transitionTimingMilliseconds = parseInt(
  getStyleProperty('--page-transition-timing').replace('ms', '')
)
export const saveData = document.body.classList.contains('save-data')
export const reducedMotion =
  window.matchMedia('(prefers-reduced-motion: reduce)').matches === true
export const pointerIsFine =
  window.matchMedia('(pointer:fine)').matches === true
export const spacing = {
  lg: getStyleProperty('--site-spacing-lg', document.documentElement, true),
}
